import Header from "./shared/header";
import TextContainer from "./shared/textContainer";
import Strategy from "./shared/strategy";
import Product from "./shared/product";
import Deployement from "./shared/deployement";
import WhitePaper from "./shared/whitepaper";
import Contact from "./shared/contact";
import Footer from "./shared/footer";

import HeroBackground from "./shared/hero_background";
import DesktopLayout from "./shared/desktop_layout";
import MobileLayout from "./shared/mobile_layout";
import { useState, useEffect } from "react";
import MobileHero from "./shared/mobile_hero";
import DesktopHero from "./shared/desktop_hero";

function DataPlatform() {
  const strategyDataMobile = [
    {
      img: "images/data-platform/platform.webp",
      title: "Hundred Foot Overview",
      description:
        "Help define an over-arching data strategy, which includes an as-is architecture, the to-be architecture and a roadmap for getting there.",
    },
    {
      img: "images/data-platform/bird.webp",
      title: "Robust Integrations with your Data Sources",
      description:
        "Implement DBT powered reliable, tested, well-documented ELT pipelines that leverage modern data platforms for transformations",
    },
    {
      img: "images/data-platform/insights.webp",
      title: "Data Governance",
      description:
        "Strong focus on data governance - including data catalog, data lineage and data quality - powered by open-source tools.",
    },
    {
      img: "images/data-platform/bird.webp",
      title: "Open Source Stack",
      description:
        "Leverage open source stack to build robust integrations to an organization’s data sources",
    },
  ];

  const strategyDataWeb = [
    {
      img: "images/data-platform/strategy/img1.png",
      title: "Strategy",
      description:
        "Help define an over-arching data strategy, which includes an as-is architecture, the to-be architecture and a roadmap for getting there.",
    },
    {
      img: "images/data-platform/strategy/img2.png",
      title: "Robust Integrations with your Data Sources",
      description:
        "Implement DBT powered reliable, tested, well-documented ELT pipelines that leverage modern data platforms for transformations",
    },
    {
      img: "images/data-platform/strategy/img3.png",
      title: "Optimized Data Infrastructure",
      description:
        "Design and manage a well-architected data warehouse, data lake or a lakehouse to suit the business needs.",
    },
    {
      img: "images/data-platform/strategy/img4.png",
      title: "Open Source Stack",
      description:
        "Leverage open source stack to build robust integrations to an organization’s data source, including technologies like dbt, Great Expectations, DataHub, Superset, Dagster, etc.",
    },
    {
      img: "images/data-platform/strategy/img5.png",
      title: "Data Governance",
      description:
        "Strong focus on data governance - including data catalog, data lineage, metadata versioning and data quality - powered by open-source tools.",
    },
  ];

  const productList = [
    {
      title: "UNified view of your data",
      description:
        "Access and explore data from marketing platforms, CRM systems, transactional systems, etc.",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <g opacity="0.5">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.9333 4.26663H3.2C2.6109 4.26663 2.13333 4.7442 2.13333 5.3333V14.9333H14.9333V4.26663ZM17.0667 4.26663V14.9333H29.8667V5.3333C29.8667 4.7442 29.3891 4.26663 28.8 4.26663H17.0667ZM14.9333 17.0667H2.13333V26.6666C2.13333 27.2557 2.6109 27.7333 3.2 27.7333H14.9333V17.0667ZM17.0667 27.7333V17.0667H29.8667V26.6666C29.8667 27.2557 29.3891 27.7333 28.8 27.7333H17.0667ZM3.2 2.1333C1.43269 2.1333 0 3.56599 0 5.3333V26.6666C0 28.4339 1.43269 29.8666 3.2 29.8666H28.8C30.5673 29.8666 32 28.4339 32 26.6666V5.3333C32 3.56599 30.5673 2.1333 28.8 2.1333H3.2Z"
              fill="black"
            />
          </g>
        </svg>
      ),
    },
    {
      title: "quality & Lineage",
      description:
        "Easily trace the lineage of data and have access to always up-to-date data quality metrics.",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <g opacity="0.5">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M24.5357 2.41943C24.9667 2.41943 25.3162 2.76887 25.3162 3.19992V28.7999C25.3162 29.231 24.9667 29.5804 24.5357 29.5804C24.1046 29.5804 23.7552 29.231 23.7552 28.7999V3.19992C23.7552 2.76887 24.1046 2.41943 24.5357 2.41943ZM20.269 6.6861C20.7001 6.6861 21.0495 7.03554 21.0495 7.46659V28.7999C21.0495 29.231 20.7001 29.5804 20.269 29.5804C19.838 29.5804 19.4885 29.231 19.4885 28.7999V7.46659C19.4885 7.03554 19.838 6.6861 20.269 6.6861ZM28.8024 6.6861C29.2334 6.6861 29.5828 7.03554 29.5828 7.46659V28.7999C29.5828 29.231 29.2334 29.5804 28.8024 29.5804C28.3713 29.5804 28.0219 29.231 28.0219 28.7999V7.46659C28.0219 7.03554 28.3713 6.6861 28.8024 6.6861ZM11.7357 8.81943C12.1667 8.81943 12.5162 9.16887 12.5162 9.59992V28.7999C12.5162 29.231 12.1667 29.5804 11.7357 29.5804C11.3046 29.5804 10.9552 29.231 10.9552 28.7999V9.59992C10.9552 9.16887 11.3046 8.81943 11.7357 8.81943ZM3.20236 10.9528C3.63341 10.9528 3.98285 11.3022 3.98285 11.7333V28.7999C3.98285 29.231 3.63341 29.5804 3.20236 29.5804C2.77131 29.5804 2.42188 29.231 2.42188 28.7999V11.7333C2.42188 11.3022 2.77131 10.9528 3.20236 10.9528ZM16.0024 10.9528C16.4334 10.9528 16.7829 11.3022 16.7829 11.7333V28.7999C16.7829 29.231 16.4334 29.5804 16.0024 29.5804C15.5713 29.5804 15.2219 29.231 15.2219 28.7999V11.7333C15.2219 11.3022 15.5713 10.9528 16.0024 10.9528ZM7.46903 15.2194C7.90008 15.2194 8.24952 15.5689 8.24952 15.9999V28.7999C8.24952 29.231 7.90008 29.5804 7.46903 29.5804C7.03798 29.5804 6.68854 29.231 6.68854 28.7999V15.9999C6.68854 15.5689 7.03798 15.2194 7.46903 15.2194Z"
              fill="black"
            />
          </g>
        </svg>
      ),
    },
    {
      title: "robust data catalog",
      description:
        "A robust data catalog, so that there is no debate about the defintion of your key performance indicators.",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <g opacity="0.5">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.19766 11.2C4.08131 11.2 4.79766 10.4837 4.79766 9.6C4.79766 8.71634 4.08131 8 3.19766 8C2.314 8 1.59766 8.71634 1.59766 9.6C1.59766 10.4837 2.314 11.2 3.19766 11.2ZM8.53099 9.6C8.53099 9.0109 9.00855 8.53333 9.59766 8.53333H28.7977C29.3868 8.53333 29.8643 9.0109 29.8643 9.6C29.8643 10.1891 29.3868 10.6667 28.7977 10.6667H9.59766C9.00855 10.6667 8.53099 10.1891 8.53099 9.6ZM9.59766 14.9333C9.00855 14.9333 8.53099 15.4109 8.53099 16C8.53099 16.5891 9.00855 17.0667 9.59766 17.0667H28.7977C29.3868 17.0667 29.8643 16.5891 29.8643 16C29.8643 15.4109 29.3868 14.9333 28.7977 14.9333H9.59766ZM9.59766 21.3333C9.00855 21.3333 8.53099 21.8109 8.53099 22.4C8.53099 22.9891 9.00855 23.4667 9.59766 23.4667H28.7977C29.3868 23.4667 29.8643 22.9891 29.8643 22.4C29.8643 21.8109 29.3868 21.3333 28.7977 21.3333H9.59766ZM4.79766 16C4.79766 16.8837 4.08131 17.6 3.19766 17.6C2.314 17.6 1.59766 16.8837 1.59766 16C1.59766 15.1163 2.314 14.4 3.19766 14.4C4.08131 14.4 4.79766 15.1163 4.79766 16ZM3.19766 24C4.08131 24 4.79766 23.2837 4.79766 22.4C4.79766 21.5163 4.08131 20.8 3.19766 20.8C2.314 20.8 1.59766 21.5163 1.59766 22.4C1.59766 23.2837 2.314 24 3.19766 24Z"
              fill="black"
            />
          </g>
        </svg>
      ),
    },
    {
      title: "browse your dataset",
      description:
        "Explore and analyze your data at scale with the elasticity provided by modern data platforms",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <g opacity="0.5">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.96287 2.1333L8.91466 2.1333C8.2575 2.13328 7.69071 2.13325 7.22653 2.17739C6.73516 2.22411 6.2498 2.32771 5.79754 2.60485C5.36696 2.86871 5.00494 3.23073 4.74109 3.66131C4.46394 4.11357 4.36034 4.59893 4.31362 5.0903C4.26948 5.55449 4.26951 6.12128 4.26953 6.77844L4.26953 6.82664V25.1733L4.26953 25.2215C4.26951 25.8787 4.26948 26.4455 4.31362 26.9096C4.36034 27.401 4.46394 27.8864 4.74109 28.3386C5.00494 28.7692 5.36696 29.1312 5.79754 29.3951C6.24981 29.6722 6.73516 29.7758 7.22653 29.8226C7.69072 29.8667 8.25751 29.8667 8.91467 29.8666H8.96287H23.0429H23.0911C23.7482 29.8667 24.315 29.8667 24.7792 29.8226C25.2706 29.7758 25.7559 29.6722 26.2082 29.3951C26.6388 29.1312 27.0008 28.7692 27.2647 28.3386C27.5418 27.8864 27.6454 27.401 27.6921 26.9096C27.7363 26.4455 27.7362 25.8787 27.7362 25.2215V25.1733V6.82664V6.77843C27.7362 6.12127 27.7363 5.55448 27.6921 5.0903C27.6454 4.59893 27.5418 4.11357 27.2647 3.66131C27.0008 3.23073 26.6388 2.86871 26.2082 2.60485C25.7559 2.32771 25.2706 2.22411 24.7792 2.17739C24.315 2.13325 23.7482 2.13328 23.0911 2.1333L23.0429 2.1333H8.96287ZM6.9122 4.42382C6.97294 4.3866 7.09325 4.33302 7.42846 4.30114C7.77955 4.26776 8.24388 4.26664 8.96287 4.26664H23.0429C23.7619 4.26664 24.2262 4.26776 24.5773 4.30114C24.9125 4.33302 25.0328 4.3866 25.0935 4.42382C25.2371 4.51177 25.3577 4.63245 25.4457 4.77597C25.4829 4.83671 25.5365 4.95702 25.5684 5.29223C25.6017 5.64332 25.6029 6.10765 25.6029 6.82664V25.1733C25.6029 25.8923 25.6017 26.3566 25.5684 26.7077C25.5365 27.0429 25.4829 27.1632 25.4457 27.224C25.3577 27.3675 25.2371 27.4882 25.0935 27.5761C25.0328 27.6133 24.9125 27.6669 24.5773 27.6988C24.2262 27.7322 23.7619 27.7333 23.0429 27.7333H8.96287C8.24388 27.7333 7.77955 27.7322 7.42846 27.6988C7.09325 27.6669 6.97294 27.6133 6.9122 27.5761C6.76868 27.4882 6.648 27.3675 6.56005 27.224C6.52283 27.1632 6.46925 27.0429 6.43737 26.7077C6.40399 26.3566 6.40287 25.8923 6.40287 25.1733V6.82664C6.40287 6.10765 6.40399 5.64332 6.43737 5.29223C6.46925 4.95702 6.52283 4.83671 6.56005 4.77597C6.648 4.63245 6.76868 4.51177 6.9122 4.42382ZM10.6695 21.3333C10.0804 21.3333 9.60287 21.8109 9.60287 22.4C9.60287 22.9891 10.0804 23.4666 10.6695 23.4666H17.0695C17.6586 23.4666 18.1362 22.9891 18.1362 22.4C18.1362 21.8109 17.6586 21.3333 17.0695 21.3333H10.6695ZM9.60287 16C9.60287 15.4109 10.0804 14.9333 10.6695 14.9333H21.3362C21.9253 14.9333 22.4029 15.4109 22.4029 16C22.4029 16.5891 21.9253 17.0666 21.3362 17.0666H10.6695C10.0804 17.0666 9.60287 16.5891 9.60287 16ZM10.6695 8.5333C10.0804 8.5333 9.60287 9.01087 9.60287 9.59997C9.60287 10.1891 10.0804 10.6666 10.6695 10.6666H21.3362C21.9253 10.6666 22.4029 10.1891 22.4029 9.59997C22.4029 9.01087 21.9253 8.5333 21.3362 8.5333H10.6695Z"
              fill="black"
            />
          </g>
        </svg>
      ),
    },
  ];

  const carouselData = [
    {
      title: "Real Time Data Processing",
      description:
        "Set up a real-time stream processing and campaign personalization engine for one of the largest banks in South East Asia. Data was collected from 15+ real-time and batch data sources to support 120+ active campaigns.",
    },
    {
      title: "Real Time Data Processing",
      description:
        "Set up a real-time stream processing and campaign personalization engine for one of the largest banks in South East Asia. Data was collected from 15+ real-time and batch data sources to support 120+ active campaigns.",
    },
  ];

  const WhitePapercardData = [
    {
      img: "images/hoots/nps-score.webp",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <g opacity="0.5">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M28.0495 15.9992C28.0495 9.95032 23.3352 3.94583 15.9961 3.94583C10.0683 3.94583 7.13888 8.33385 5.89082 10.6667H9.59948C10.1886 10.6667 10.6661 11.1442 10.6661 11.7333C10.6661 12.3224 10.1886 12.8 9.59948 12.8H3.19948C2.61038 12.8 2.13281 12.3224 2.13281 11.7333V5.33333C2.13281 4.74423 2.61038 4.26667 3.19948 4.26667C3.78858 4.26667 4.26615 4.74423 4.26615 5.33333V9.19471C5.77097 6.54413 9.24715 1.8125 15.9961 1.8125C24.6635 1.8125 30.1828 8.92802 30.1828 15.9992C30.1828 23.0703 24.6635 30.1858 15.9961 30.1858C11.8493 30.1858 8.39669 28.545 5.93846 26.0438C4.62227 24.7045 3.59434 23.1224 2.89349 21.4194C2.66929 20.8747 2.92916 20.2513 3.47394 20.0271C4.01871 19.8029 4.64209 20.0627 4.86629 20.6075C5.4654 22.0633 6.34265 23.4115 7.45998 24.5484C9.53319 26.6579 12.444 28.0525 15.9961 28.0525C23.3352 28.0525 28.0495 22.048 28.0495 15.9992ZM15.9995 8.53333C16.5886 8.53333 17.0661 9.0109 17.0661 9.6V15.5582L21.0204 19.5124C21.437 19.929 21.437 20.6044 21.0204 21.0209C20.6038 21.4375 19.9285 21.4375 19.5119 21.0209L15.2452 16.7542C15.0452 16.5542 14.9328 16.2829 14.9328 16V9.6C14.9328 9.0109 15.4104 8.53333 15.9995 8.53333Z"
              fill="black"
            />
          </g>
        </svg>
      ),
      title: "Reduction in Campaign Downtime",
      description:
        "Provided end-to-end marketing data management and analytics for an American health insurance company. This reduced average campaign reconfiguration time down to just 4 days, down from 15 days.",
    },
    {
      img: "images/hoots/XXX.webp",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="33"
          viewBox="0 0 32 33"
          fill="none"
        >
          <g opacity="0.5">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.6667 2.35013C10.6667 1.17192 11.6218 0.216797 12.8 0.216797H19.2C20.3782 0.216797 21.3333 1.17192 21.3333 2.35013V4.48346H29.8667C31.0449 4.48346 32 5.43859 32 6.6168V13.0168C32 14.9129 31.1745 16.6165 29.8667 17.7871V24.7501C29.8667 26.5174 28.434 27.9501 26.6667 27.9501H5.33333C3.56602 27.9501 2.13333 26.5174 2.13333 24.7501V17.7867C0.825536 16.6162 0 14.913 0 13.0168V6.6168C0 5.43859 0.955127 4.48346 2.13333 4.48346H10.6667V2.35013ZM19.2 2.35013V4.48346H12.8V2.35013L19.2 2.35013ZM2.13333 6.6168H10.6667H11.7333H20.2667H21.3333H29.8667V13.0168C29.8667 14.412 29.1981 15.6508 28.1594 16.431C27.4464 16.9665 26.5617 17.2835 25.6 17.2835H17.0667V16.2168C17.0667 15.6277 16.5891 15.1501 16 15.1501C15.4109 15.1501 14.9333 15.6277 14.9333 16.2168V17.2835H6.4C5.4385 17.2835 4.55381 16.9663 3.84062 16.4306C2.80181 15.6503 2.13333 14.4119 2.13333 13.0168V6.6168ZM14.9333 19.4168H6.4C5.65249 19.4168 4.93424 19.2882 4.26667 19.0521V24.7501C4.26667 25.3392 4.74423 25.8168 5.33333 25.8168H26.6667C27.2558 25.8168 27.7333 25.3392 27.7333 24.7501V19.0523C27.0657 19.2883 26.3474 19.4168 25.6 19.4168H17.0667V20.4835C17.0667 21.0726 16.5891 21.5501 16 21.5501C15.4109 21.5501 14.9333 21.0726 14.9333 20.4835V19.4168Z"
              fill="black"
            />
          </g>
        </svg>
      ),
      title: "Daily Transaction Processing",
      description:
        "Processed in real-time more than 12B transactions/day for a telecommunications company in the Middle East to allow real-time analytics and campaigns",
    },
  ];

  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const Layout = ({ children, backgroundColor }) => {
    return screenSize <= 768 ? (
      <MobileLayout backgroundColor={backgroundColor}>{children}</MobileLayout>
    ) : (
      <DesktopLayout backgroundColor={backgroundColor}>
        {children}
      </DesktopLayout>
    );
  };

  return (
    <div>
      <DesktopHero
        heroImage={"images/data-platform/hero.webp"}
        heading="Deploy a Modern Data Stack to handle current and future data
        management needs"
        title={"DATA PLATFORMS"}
        backgroundColor="orange"
        name="data-platform"
      />

      <MobileHero
        heading={
          "Deploy a Modern Data Stack to handle current and future data management needs"
        }
        title={"DATA PLATFORMS"}
        backgroundColor="orange"
      />

      <Layout>
        <div className=" sm:hidden w-[88%] mx-auto">
          <div>&nbsp;</div>
          <img
            src="/images/data-platform/hero.webp"
            alt="frame1"
            className=" mt-[40px]"
          />
        </div>
      </Layout>

      <Layout>
        <TextContainer
          text1="OneByZero has an experienced data team consisting of data architects and engineers that can help design the right data platforms for your needs, and bring trust, governance, reliability and scale to your data management."
          text2="Make the right data platform choices, build and deploy the platform and manage it to drive all your use-cases."
        />
      </Layout>

      <Layout backgroundColor="black">
        <Strategy
          title={"Why work with OneByZero to define your data strategy?"}
          description={
            "OneByZero has deep experience in designing, building and managing large-scale complex data platforms with strong governance."
          }
          img="images/data-platform/strategy.webp"
          dataMobile={strategyDataMobile}
          dataWeb={strategyDataWeb}
        />
      </Layout>

      <Layout>
        <Product
          title={"Take your products to the next level with LLMs"}
          description={
            "Enterprises face major challenges in having access to trustworthy data. OneByZero can help you overcome this!"
          }
          list={productList}
        />
      </Layout>

      {/* <Layout backgroundColor="black">
        <Deployement
          title={"Accelerated Deployment"}
          description={
            "OnebyZero’ uses several accelerators in the space of XXXX to speed up the deployment of use-cases."
          }
          text1={
            "Hyper-personalized content generation for marketing and customer engagement use-cases"
          }
          text2={"Generation of data stories, especially video data stories"}
          text3={
            "Collection, indexing and serving of data for enterprise search systems"
          }
        />
      </Layout> */}

      <Layout>
        <WhitePaper
          heading={"Meet your business goals with Data Platforms"}
          subHeading={"Welcome to the future of business."}
          title={"Go Deeper with Data Platforms"}
          description={
            "Discover how you can improve customer satisfaction rates and lower churn by increasing the number of channels you interact with customers"
          }
          carouselData={carouselData}
          cardData={WhitePapercardData}
        />
      </Layout>

      <Layout backgroundColor="black">
        <Contact
          title={
            "See how Data Platforms can revolutionize your business, and improve customer engagement and employee productivity"
          }
          type="service"
        />
        <Footer />
      </Layout>
    </div>
  );
}

export default DataPlatform;
